import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { AppSEO } from "./AppSEO";
import { Error } from "./Error";
export const ServerError = ({ redirectUrl = "/", buttonLabel = "Return to dashboard", }) => {
    const loadSmallImage = (onLoad) => import("../../assets/images/moon-sm.jpg").then((img) => onLoad(img.default));
    const loadLargeImage = (onLoad) => import("../../assets/images/moon.jpg").then((img) => onLoad(img.default));
    return (_jsxs(_Fragment, { children: [_jsx(AppSEO, { title: "An error occurred" }), _jsx(Error, { code: 500, description: "Internal server error", loadSmallImage: loadSmallImage, loadLargeImage: loadLargeImage, redirectUrl: redirectUrl, buttonLabel: buttonLabel })] }));
};
